var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Edit_Button",
    "data-name": "Edit Button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 32,
    height: 32,
    rx: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M9.8,24.972c-5.991,0-8.551-2.56-8.551-8.551V9.8C1.25,3.81,3.81,1.25,9.8,1.25h2.207a.828.828,0,1,1,0,1.655H9.8c-5.086,0-6.9,1.809-6.9,6.9v6.62c0,5.086,1.809,6.9,6.9,6.9h6.62c5.086,0,6.9-1.809,6.9-6.9V14.214a.828.828,0,1,1,1.655,0v2.207c0,5.991-2.56,8.551-8.551,8.551Z",
    transform: "translate(-1.25 -0.971)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M6.983,18.731a2.483,2.483,0,0,1-.651-2.152l.474-3.321a3.827,3.827,0,0,1,.96-1.92l8.694-8.694c2.2-2.2,4.424-2.2,6.62,0A4.607,4.607,0,0,1,24.714,6.3a4.908,4.908,0,0,1-1.633,2.957l-8.694,8.694a3.827,3.827,0,0,1-1.92.96l-3.321.474a1.84,1.84,0,0,1-.419.033A2.47,2.47,0,0,1,6.983,18.731Zm1.953-6.223a2.245,2.245,0,0,0-.5.982l-.474,3.321a.866.866,0,0,0,.188.75.866.866,0,0,0,.75.188l3.321-.474a2.187,2.187,0,0,0,.982-.5L21.9,8.084a3.386,3.386,0,0,0,1.147-1.953A3.063,3.063,0,0,0,21.9,3.8c-1.765-1.765-2.979-1.269-4.27.011Z",
    transform: "translate(-0.728 -0.998)",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M20.217,10.463a8.757,8.757,0,0,1-6.024-6.024.838.838,0,0,1,.574-1.026.821.821,0,0,1,1.015.574,7.089,7.089,0,0,0,4.877,4.877.833.833,0,0,1,.574,1.026.812.812,0,0,1-.794.607A.711.711,0,0,1,20.217,10.463Z",
    transform: "translate(0.084 -0.751)",
    fill: "#15345a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.ee7d60dc9d1cb7b0e0887fa9bcfbbea8.svg";
export { ForwardRef as ReactComponent };